<template>
    <v-card :loader="loading">
        <v-form ref="form" :values="profile" :validate="validate" @submit="handleSubmit" :readonly="isSaving">
            <template scope="api">
                <div v-padding="3">
                    <v-row v-if="profile.activityType === 1" v-margin.bottom="3">
                        <v-col xs="12" sm="6">
                            <v-text type="title">Компания</v-text>
                            <v-form-input v-margin.top="2" field="orgName" label="Название *" />
                            <v-form-input v-margin.top="2" field="orgType" select :items="orgTypes"
                                label="Форма собственности *" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col xs="12" sm="6">
                            <v-text type="title">Реквизиты</v-text>
                            <v-form-input v-margin.top="2" field="inn" type="number" label="ИНН *" maxlength="12" />
                            <v-form-input v-if="profile.activityType === 1" v-margin.top="2" field="kpp" type="number" label="КПП *" maxlength="9" />
                            <v-form-input v-if="profile.activityType === 1" v-margin.top="2" field="ogrn" type="number" label="ОГРН *" maxlength="15" />
                            <v-form-input v-else-if="profile.activityType === 2" v-margin.top="2" field="ogrn" type="number" label="ОГРН ИП *" maxlength="15" />
                            <v-form-input v-margin.top="2" field="bik" type="number" label="БИК *" maxlength="9" />
                            <v-form-input v-margin.top="2" field="bankName" label="Банк *" />
                            <v-form-input v-margin.top="2" field="paymentAccount" type="number" label="Р / счет *"
                                maxlength="20" />
                            <v-form-input v-margin.top="2" field="correspondentAccount" type="number" label="К / счет *"
                                maxlength="20" />
                        </v-col>
                        <v-col v-if="profile.activityType == 1" xs="12" sm="6" v-margin.xs.top="3" v-margin.sm.top="0">
                            <v-text type="title">Руководитель</v-text>
                            <v-form-input v-margin.top="2" field="firstName" label="Имя *" />
                            <v-form-input v-margin.top="2" field="lastName" label="Фамилия *" />
                            <v-form-input v-margin.top="2" field="middleName" label="Отчество *" />
                            <v-form-input v-margin.top="2" field="post" label="Должность *" />
                            <v-form-input v-margin.top="2" field="basisPost" label="На основании *" />
                        </v-col>
                        <v-col v-else xs="12" sm="6">
                            <v-text type="title">Личные данные</v-text>
                            <v-form-input v-margin.top="2" field="contactFio" label="ФИО *" />
                            <v-form-input v-margin.top="2" field="contactPhone" label="Телефон *" mask="phone" />
                            <v-form-input v-margin.top="2" field="contactEmail" label="Email *" type="email" />
                        </v-col>
                    </v-row>

                    <v-row v-margin.top="3" v-if="profile.activityType == 1">
                        <v-col xs="12" sm="6">
                            <v-text type="title">Контактное лицо</v-text>
                            <v-form-input v-margin.top="2" field="contactFio" label="ФИО *" />
                            <v-form-input v-margin.top="2" field="contactPhone" label="Телефон *" mask="phone" />
                            <v-form-input v-margin.top="2" field="contactEmail" label="Email *" type="email" />
                        </v-col>
                    </v-row>

                    <v-row v-margin.top="3">
                        <v-col xs="12" sm="6">
                            <div>
                                <v-text type="title">Юридический адрес</v-text>
                            </div>

                            <v-form-input v-margin.top="1" field="addressUr" label="Юридический адрес *" />
                        </v-col>
                        <v-col xs="12" sm="6" v-margin.xs.top="3" v-margin.sm.top="0">
                            <div>
                                <v-text type="title">Почтовый адрес</v-text>
                            </div>

                            <v-form-input v-margin.top="1" field="addressPost" label="Почтовый адрес *" />
                        </v-col>
                    </v-row>
                </div>

                <div v-padding="3">
                    <v-row align-items="center">
                        <v-col v-text-align.right>
                            <v-spinner :active="isSaving">

                                <v-text v-if="error" danger v-margin.right="2" v-padding.top="1">
                                    {{ error }}
                                </v-text>

                                <v-button v-margin.right="2" flat primary @click="$router.push({ name: 'profile' })">
                                    отмена
                                </v-button>

                                <v-button type="submit" primary :disabled="api.isInvalid">
                                    сохранить
                                </v-button>
                            </v-spinner>
                        </v-col>
                    </v-row>
                </div>
            </template>
        </v-form>
    </v-card>
</template>
<script>
import { validateForm } from './validate';

export default {
    name: 'profile-info-edit',
    props: {
        individualId: Number,
        orgTypes: Array,
        loading: {
            type: Boolean,
            default: false,
        },
        companyFullName: {
            type: String,
            default: '',
        },
        profile: {
            type: Object,
            default() {
                return {
                };
            }
        },
        onSave: Function,
    },
    data() {
        return {
            isSaving: false,
            error: ''
        }
    },
    watch: {
        profile() {
            // данные могут быть некорректными, надо сразу же отобразить ошибки
            const values = this.$refs.form.getValues();
            Object.keys(values).map((field) => {
                this.$refs.form.setTouched(field, true);
            });
        }
    },
    methods: {
        validate(values) {
            return validateForm(values);
        },
        handleSubmit(values) {

            if (this.isSaving) {
                return;
            }

            const filteredValues = Object.keys(values)
                .reduce((newValues, field) => {
                    switch (true) {
                        case values[field] === undefined:
                        case values[field] === null:
                        case values[field].toString().length === 0:
                            return newValues;
                        case field === 'coincidence':
                            newValues[field] = values[field];
                            break;
                        case field === 'addressUr':
                            newValues[field] = values[field];
                            newValues.addressPost = values.coincidence
                                ? values.addressUr
                                : values.addressPost;
                            break;
                        case field === 'addressPost':
                            newValues[field] = values.coincidence
                                ? values.addressUr
                                : values.addressPost;
                            break;
                        case field === 'orgType':
                             newValues[field] = values.orgType.id;
                             break;
                        default:
                            newValues[field] = values[field].toString().trim();
                    }

                    return newValues;
                }, {});

            this.isSaving = true;

            this.onSave(filteredValues)
                .then((res) => {
                    this.isSaving = false;
                    this.$router.push({ name: 'profile' });
                })
                .catch((res) => {
                    console.log(res)
                    this.isSaving = false;
                    this.error = res.data.message
                });
        }
    },
}
</script>



// WEBPACK FOOTER //
// ProfileInfoEdit.vue?66916333